import React, {useState, useEffect, useContext} from 'react';
import {Box, LinearProgress, Button,FormControl,InputLabel,
    MenuItem, TextField
} from "@material-ui/core";
import TablaAsistencia from './TablaAsistencia';
import axios from "axios";
import qs from "qs";
import moment from 'moment';
import { useHistory } from "react-router-dom";
import IntervaloSelect from './IntervaloTabla';
import IconBuscar from '../generales/Iconos/IconBuscar';
import { authUser } from '../funciones/AuthUser'
import {llamadaApiToken,llamaApiCargaToken,ErrorGeneral } from '../funciones/ClienteAxios';
import {AuthContext} from '../context/AuthContext'
import {GeneralesContext} from '../context/GeneralesContext'
import SelectList from '../generales/SelectList';
import { obtenDispo } from '../funciones/IdDispositivo';
import {findNumberCad} from '../funciones/FindNumber'
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import ModalAbogado from './NvoAbogado';
const Abogados = () => {
    let history = useHistory();         
    const auxDispV =obtenDispo()      
    const source = axios.CancelToken.source();
    //let token =localStorage.getItem('token20') ;  
    const usuId =localStorage.getItem('UsuId') ;     
    const usu= localStorage.getItem('UsuarioNom');  
    const nvl= localStorage.getItem('Tipo');       
    const cadena = localStorage.getItem("Operacion")+"|"; 
    const {usuario,guardarUsuario}= useContext(AuthContext);
    const {generales,guardarGenerales}= useContext(GeneralesContext);                    
    const [listSuge, setListSuge] = useState([])
    const [modNvoAbog,setModNvoAbog] = useState(false)
    const[listExcel, setListExcel] = useState([])  
    const [fSelect, setFSelect] = useState({inicio:new Date(),final:new Date()});    
    const [filtro, setFiltro] = useState({Nombre:"", Municipio:0, Seccion:"",tipoDet:"", Descr:""})
    const [espera, setEspera] = useState(false)
    const [actualizar, setActualizar] = useState(false)
    const {Nombre, Municipio, Seccion,tipoDet, Descr}= filtro

    useEffect(() => {                
        veriSesion()
        if (usuId !== null && usuId !== undefined  ) 
        {
            guardarGenerales({...generales,Titulo:'Abogados'})            
        }
        else
        {   
            localStorage.clear();                            
            history.push("/");  
        }
         if (usuario.length===0) 
        {   guardarUsuario({Nombre:usu,nivel:nvl});                                                           
        }     
        
        return ()=> {
            source.cancel();
        }  
    }, [])

    useEffect(() => {                        
        llenaListSug()
    }, [actualizar])

    const veriSesion =  () => {            
        let auxValidacion=authUser()
        if(!auxValidacion ||(usu===undefined||usu===''||usu===null)||(nvl===undefined||nvl===''||nvl===null)
            ||(usuId===undefined||usuId===''||usuId===null) )
        {   guardarUsuario([])				
            guardarGenerales([])    
            localStorage.clear();            	             
            history.push("/")	                	
        }
        else
        {   if (usuario.length==0) 
            {   guardarUsuario({Nombre:usu,nivel:nvl});                                                         
            }                                
        }   
    }

    const llenaListSug = () => {
        const fInicio=moment(fSelect.inicio).format("YYYY-MM-DD");
        const fFinal=moment(fSelect.final).format("YYYY-MM-DD");
        const data = qs.stringify({
            usuario:usuId,
            fini:fInicio+"T00:00:00",
            ffin:fFinal+"T23:59:59",
            status:0,
            tipo:0,
            municipio:0,
            cadena:"",
            ip:"127.0.0.0",
            idDispositivo: auxDispV,
        });
        const url = "abogado/filtro";
        function respuestaListSug(auxiliar) {
            if (auxiliar[0].Id !== -1) {
                if (findNumberCad('|36|',cadena) ) {
                    const  arrM=[["#","Fecha Registro", "Cedula",   "Nombre", "Télefono", "Email"]]              
                    auxiliar.forEach((row,index) => {
                        const auxFReg =
                            moment.utc(row.Fecha).format("YYYY-MM-DD HH:mm") === "1900-01-01 00:00"
                            ? ""
                            : moment.utc(row.Fecha).format("DD/MM/YYYY HH:mm");                                           
                        arrM.push([index+1,auxFReg, row.Cedula, `${row.Nom} ${row.Pat} ${row.Mat}`, row.Tel,  row.Email])
                    });         
                    setListExcel(arrM)    
                }
                
                setListSuge(auxiliar);      
            }else{
                setListSuge([]);      
            }
        }
    
        llamaApiCargaToken(data, url, respuestaListSug,ErrorGeneral,setEspera,history,source);
    };


    
    const btnBuscar=(e)=>{
        e.preventDefault()
       // llenaListSug()
       setActualizar(!actualizar)
    }           
    const modalNvoAb= modNvoAbog ? <ModalAbogado modalAbierto={modNvoAbog} setModalAbierto={setModNvoAbog}  titulo="Nuevo Abogado" funcActualizar={()=>{setActualizar(!actualizar)}} />:null
    return (
    <div style={{marginLeft:.5+'rem'}} >
        {modalNvoAb}
        <Box display={'flex'} mt={2} mb={1}>
            <Box >
              <IconBuscar leyenda="Buscar" handleClick={(e)=>btnBuscar(e)} />   
                                                                                                                                    
            </Box>    
            <Box>
                <IntervaloSelect fSelect={fSelect}  setFSelect={setFSelect} />
            </Box>  
             <Button onClick={()=>{setModNvoAbog(true)}} style={{width:"13rem", marginTop:".5rem", marginLeft:".5rem", backgroundColor:process.env.REACT_APP_Btn_Color}}  
                variant="contained"  color="primary"  startIcon={<AddCircleOutlineIcon/>} >   
                Agregar Abogado     
            </Button>                                          
        </Box>
        { !espera  ? <TablaAsistencia listSuge={listSuge}  listaExcel={listExcel} />
            :    <Box pt={3}><LinearProgress/> </Box>
        }
        
    </div>
    );
};

export default Abogados;